import { render } from "./Roles__Management.vue?vue&type=template&id=116a2851&scoped=true"
import script from "./Roles__Management.vue?vue&type=script&lang=js"
export * from "./Roles__Management.vue?vue&type=script&lang=js"

import "./Roles__Management.vue?vue&type=style&index=0&id=116a2851&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116a2851"]])

export default __exports__